import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {

    gtagConversionEvent() {
        if (environment.enableTagManagerCall === false) {
            return;
        }

        const gtag = (window as any).gtag;

        if (gtag) {
            const eventKey = environment.tagManagerConversionEvent;
                                                                  // 'AW-17048822730/npmUCPiv3_oaEMrHwcE_
            gtag('event', 'conversion', { 'send_to': eventKey }); // 'AW-17048822730/VkrtCJy5p-gaEMrHwcE_' });
        }
    }
}